import { EMPTY_FIELD } from 'constants/emptyField';

import { useRecordContext } from 'react-admin';
import { Avatar } from 'shared/mui/Avatars/Avatar/Avatar';
import { User } from 'types/embedded/user';

import { StyledAvatarGroup } from './WorkTeamsList.styled';

export const WorkTeamsListMembersAvatars = (): JSX.Element => {
  const record = useRecordContext<User[]>();

  if (!record || !record.length) {
    return <span>{EMPTY_FIELD}</span>;
  }

  return (
    <StyledAvatarGroup max={5}>
      {record?.map((user) => (
        <Avatar
          key={user.id}
          sx={{ width: 24, height: 24, fontSize: '8px' }}
          title={`${user.firstName} ${user.lastName}`}
        >
          {`${user.firstName[0]}${user.lastName[0]}`.toUpperCase()}
        </Avatar>
      ))}
    </StyledAvatarGroup>
  );
};
